import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const errMsg = (e, fallback = "Something went wrong. Please try again.") =>
  e?.response?.data?.detail && typeof e.response.data.detail === "string" ? e.response.data.detail : fallback;

export const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const mediaUrl = (src) => (src?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src);

export const fmtSlot = (t) => {
  const [h, m] = t.split(":").map(Number);
  const hh = h % 12 || 12;
  return `${hh}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};
